<template>
    <div>
        <v-offline
            online-class="online"
            offline-class="offline"
            @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>

        <div class="row setMarginTop">
            <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
                <div class="card setShadow">
                    <div class="card-header">
                        <div class="containBytitile">
                            <h4 class="card-title">Report by Map</h4>
                        </div>
                        <hr>
                    </div>
                    <div class="card-body" style="padding: 10px;">

                        <div class="row">

                            <div class="col-md-3">
                                <p>Select Date(s)</p>
                                <el-select v-model="dateFilterOption">
                                    <el-option value="All">All</el-option>
                                    <el-option value="Catch Date Range">Catch Date Range</el-option>
                                </el-select>
                            </div>

                            <div class="col" v-if="dateFilterOption==='Catch Date Range'">
                                <p>Select Date(s)</p>
                                <v-md-date-range-picker class="daterangepicker" :presets="dateRangePresets" :start-date="startDatePast" :end-date="endDatePast"
                                                        @change="handleChange"
                                                        style="width:100% !important"></v-md-date-range-picker>
                            </div>

                            <div class="col">
                                <p>Animal Id</p>
                                <fg-input type="text" placeholder="Enter Animal ID" v-model="dog_id"></fg-input>
                            </div>

                            <div class="col">
                                <br>
                                <button v-bind:disabled="!onLine" type="button" class="btn btn-primary"
                                        @click="getFilterReportRecordsBySearch()">Search
                                </button>
                            </div>
                        </div>

                        <div class="legend-div">
                            <br>
                            <h6>Caught Locations</h6>

                            <label class="label-color" style="background-color: #0000ff;"></label>
                            <span class="type-span">Male</span>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <label class="label-color" style="background-color: #ff0000;"></label>
                            <span class="type-span">Female</span>
                        </div>

                        <MapBase
                            v-if="isDataLoaded"
                            :enableCluster="true"
                            :pins="markers"
                            :zoom="5"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from '../../../../mixins/GlobalMixin';
import dateRangeDefaultPresetsMixin from '../../../../mixins/DateRangeDefaultPresetsMixin';
import VOffline from 'v-offline';
import {Select, Option,} from 'element-ui';
import Vue from 'vue';
import VMdDateRangePicker from "v-md-date-range-picker";

import haversine from 'haversine-distance'
import { globalLogo200x200 } from '../../../../config';
import MapBase from '../../../map/MapBase.vue';

Vue.use(VMdDateRangePicker);

export default {
    components: {
        [Option.name]: Option,
        [Select.name]: Select,
        VOffline,
        MapBase
    },
    props: {
        projectId: {
            type: Number,
        }
    },
    data() {
        return {

            dateFilterOption: 'All',

            markers: [],
            center: {lat: 33.8291523, lng: -116.8004315},
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            },
            currentMarkerContent: {
                photo: globalLogo200x200,
                hsappsId: '',
                caughtDate: '',
                collarId: '',
                caughtMethod: '',
                ownership: '',
                gender: '',
                species: '',
                dropOffLatLng: '',
                dropOffDistance: 'TBD'
            },
            infoWindowPos: null,
            infoWinOpen: false,
            startDate: '',
            endDate: '',
            dog_id: '',
            project_id: '',
            startDatePast: '',
            endDatePast: '',
            dateRangePresets: [],
            isDataLoaded: false
        }
    },
    mixins: [mixin, dateRangeDefaultPresetsMixin],
    methods: {
        markersclick(marker, idx) {
            this.infoWindowPos = marker.postion;
            this.infoContent = marker.icon;

            this.currentMarkerContent.photo = marker.photo
            this.currentMarkerContent.hsappsId = marker.hsappsId
            this.currentMarkerContent.caughtDate = marker.caughtDate
            this.currentMarkerContent.collarId = marker.collarId
            this.currentMarkerContent.caughtMethod = marker.caughtMethod
            this.currentMarkerContent.ownership = marker.ownership
            this.currentMarkerContent.gender = marker.gender
            this.currentMarkerContent.species = marker.species

            if (this.currentMidx == idx) {
                this.infoWinOpen = !this.infoWinOpen;
            } else {
                this.infoWinOpen = true;
                this.currentMidx = idx;
            }
        },
        handleChange(values) {
            var sDate = this.formatDate(values[0]._d);
            var eDate = this.formatDate(values[1]._d);
            this.startDate = sDate;
            this.endDate = eDate;
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        getFilterReportRecordsBySearch() {
            let vm = this;

            if (vm.dateFilterOption === 'Catch Date Range') {
                if (vm.startDate === '' || vm.endDate === '') {

                    this.startDate = vm.formatDate(vm.dateRangePresets[4].range[0]);
                    this.endDate = vm.formatDate(vm.dateRangePresets[4].range[1]);

                }
            } else if (vm.dateFilterOption === 'All') {
                this.startDate = '';
                this.endDate = '';
            }

            vm.markers = [];
            const loading = this.$loading({
                lock: true,
                text: 'Loading...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios.get('/pm/reports/map/' + vm.project_id, {
                params: {
                    start_date: vm.startDate,
                    end_date: vm.endDate,
                    dog_id: vm.dog_id
                }
            }).then(response => {
                vm.uniqueid = '';
                vm.rfid = '';
                if (response.data.response.error.error_code == 0) {
                    const record = response.data.response.data.records;
                    if (record.length == 0) {
                        this.showAlert('Error', "No Results", false);
                    } else {
                        record.map((item) => {
                            const latLng = item.caught_location.split(",");
                            const latitude = latLng[0];
                            const longitude = latLng[1];
                            const iconUrl = item.gender.toLowerCase() == 'male' ? 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png' : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'

                            let dropOffDistance = 'TBD'
                            let dropOffLatLng = ''
                            if (item.dropoff_lat_lng != null) {
                                dropOffLatLng = item.dropoff_lat_lng
                                const latLng2 = dropOffLatLng.split(",");
                                const latitude2 = latLng2[0];
                                const longitude2 = latLng2[1];
                                const a = {latitude: latitude, longitude: longitude}
                                const b = {latitude: latitude2, longitude: longitude2}
                                dropOffDistance = haversine(a, b) + 'm away'
                            }

                            const obj = {
                                lat: parseFloat(latitude),
                                lng: parseFloat(longitude),
                                markerConfig: {
                                    iconUrl,
                                    popupConfig: {
                                        minWidth: 380
                                    }
                                },
                                popupText: `<div style="display:flex;align-items:flex-start;gap:10px"><img src="${item.image_url}" style="width:150px;height:150px;object-fit:cover;padding:5px"><table><tr><td><strong>App ID:</strong></td><td>${item.hsapps_id}</td></tr><tr><td><strong>Caught Date:</strong></td><td>${vm.convertDate(item.caught_date)}</td></tr><tr><td><strong>Collar ID:</strong></td><td>${item.collar_id}</td></tr><tr><td><strong>Caught Method:</strong></td><td>${item.caught_method}</td></tr><tr><td><strong>Ownership:</strong></td><td>${item.ownership}</td></tr><tr><td><strong>Gender:</strong></td><td>${item.gender}</td></tr><tr><td><strong>Species:</strong></td><td>${item.species}</td></tr><tr><td><strong>Release Location:</strong></td><td>${dropOffLatLng} (${dropOffDistance})</td></tr></table></div>`
                            }
                            vm.markers.push(obj);
                        });
                        if (vm.markers.length != 0) {
                            vm.center = vm.markers[0].postion;
                        }
                        vm.isDataLoaded = true;
                    }
                }
            })
            .finally(() => {
                loading.close();
            });
        }
    },
    mounted() {
        let vm = this;
        vm.project = vm.$store.getters.getCurrentSelectedProject;
        vm.project_id = vm.project.id;
        //Bus.$emit("projectype", vm.project);
        try {
            setTimeout(function () {
                var x = document.getElementsByTagName("label")[0].textContent = "";
                var dateSize = document.getElementsByClassName("text-field__filled")[0];
                dateSize.style.width = '100%';
            }, 50);
        } catch (e) {
            console.log(e)
        }

        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.startDatePast = firstDay.toLocaleDateString('en-US');
        this.endDatePast = lastDay.toLocaleDateString('en-US');
        this.dateRangePresets = this.getDateRangePresets();
        this.getFilterReportRecordsBySearch();
    }
}

</script>
<style>
.bar {
    display: none !important;
}

.mdrp__activator .activator-wrapper .text-field__filled ~ label {
    display: none !important;
}

</style>
<style scoped>

td {
    padding: 2px;
}

.setShadow {
    box-shadow: 0 6px 10px 0px rgba(0, 0, 0, 0.15) !important;
}

.btn {
    margin: 0px !important;
}

p {
    margin-top: 0;
    margin-bottom: 0rem;
}

.set_div_posi {
    margin-top: 23px;
    text-align: right;
}

.img_marker_popup {
    height: 70px;
    width: 70px;
}

.legend-div {
    margin: 0px 0px 8px 0px;
}

.label-color {
    width: 12px;
    height: 12px;
    margin-bottom: 0px !important;
    border-radius: 3px;
    margin-right: 5px;
}

.type-span {
    margin-right: 5px;
    font-size: 15px;
}

.daterangepicker {
    z-index: 9999;
}
</style>
